module.exports = __webpack_public_path__ + "static/typea-0978de47ab700b72f41c2bb42b1eb5cc.png";